import { isPlatformBrowser } from "@angular/common";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Inject, PLATFORM_ID } from "@angular/core";
import { Observable } from "rxjs";
import { AppClientContext } from "./client-context.base";
import { EntityDataServiceBase } from "./entity-data-service.base";

export class EntityDataServiceWithProcessingBase extends EntityDataServiceBase
{
  constructor(@Inject(PLATFORM_ID) protected platformId,
    protected http: HttpClient,
    public apiUrl: string)
  {
    super(http, apiUrl);
  }

  /** 
* Show Processing component when change tab steps of cart
*/
  protected _loadingMaskHandleObservableResponse(subject: Observable<any>): void
  {
    if (!isPlatformBrowser(this.platformId))
    {
      return;
    }

    /* Call api context */
    const random = Math.random().toString().substring(2);
    const dataServiceTokenName = (<any>this.constructor).name + "_" + random;

    AppClientContext.Instance.setDataServiceBusy(dataServiceTokenName);

    /* suscribe response */
    subject.subscribe({
      next: () => 
      {
        AppClientContext.Instance.setDataServiceDone(dataServiceTokenName);
      },
      error: (response: HttpErrorResponse) =>
      {
        try
        {
          // Not Found
          if (response && response.status == 404)
          {
            return;
          }

          // Unauthorized
          if (response && response.status == 401)
          {
            if (response.statusText != "Unauthorized")
            {
              window.location.href = "/";
            }

            return;
          }

          if (response && response.status == 500)
          {
            // Not in cache
            if (response.error && response.error.message == "User not in Cache... possibly timed out.")
            {
              window.location.href = "/";
            }

            return;
          }

          // Outage
          if (response && response.status == 503)
          {
            return;
          }
        }
        finally
        {
          AppClientContext.Instance.setDataServiceDone(dataServiceTokenName);
        }
      }
    });
  }
}
